<script setup lang="ts">
import LeButton from "@dsk/components/Button/LeButton.vue";
import { useI18n } from "vue-i18n";

import { config } from "@/config";

import LeErrorResult from "./LeErrorResults.vue";

const { t } = useI18n();
const { language } = config.app;
</script>

<template>
  <LeErrorResult>
    <template #header>
      {{ t("le-error-results.user-licenses-expired.headline") }}
    </template>
    <template #paragraph1>
      {{ t("le-error-results.user-licenses-expired.paragraph") }}
    </template>
    <template #button>
      <LeButton tag="a" :href="`/${language}/subscription/`" variant="outline">{{
        t("le-error-results.user-licenses-expired.button")
      }}</LeButton>
    </template>
  </LeErrorResult>
</template>
